import en from "./en.json"
import fr from "./fr.json"
import { en as vuetifyEN, fr as vuetifyFR } from "vuetify/locale"

export type MessageSchema = typeof fr

const messages = {
  en: { ...en, $vuetify: vuetifyEN },
  fr: { ...fr, $vuetify: vuetifyFR },
}

export default messages
